/* istanbul ignore file */

export default function getVideoTypeByBrowser() {
  return MediaRecorder.isTypeSupported("video/mp4") ? "mp4" : "webm";
}
